import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService, CurrentUser } from '@/core/services/auth-service';
import { Observable } from 'rxjs';
import { Card } from 'primeng/card';

@Component({
  standalone: true,
  selector: 'app-stats-widget',
  imports: [CommonModule, Card],
  template: `
    <!-- ساعت -->
    <div class="col-span-12 lg:col-span-6 xl:col-span-3">
      <div class="card mb-0" style="background:#f59e0b; color:#fff;">
        <div class="flex justify-between mb-4">
          <div>
            <span class="block font-medium mb-2" style="opacity:.9;">ساعت</span>
            <div class="font-medium text-3xl" style="letter-spacing:1px;">{{ time }}</div>
          </div>
          <div class="flex items-center justify-center rounded-border bg-white" style="width: 2.5rem; height: 2.5rem;">
            <i class="pi pi-clock text-xl!" style="color:#f59e0b;"></i>
          </div>
        </div>
        <span class="font-medium" style="opacity:.9;">به سامانه خوش آمدید</span>
      </div>
    </div>

    <!-- شرکت -->
    <div class="col-span-12 lg:col-span-6 xl:col-span-3">
      <div class="card mb-0" style="background:#06b6d4; color:#fff;">
        <div class="flex justify-between mb-4">
          <div>
            <span class="block font-medium mb-2" style="opacity:.9;">مجموعه</span>
            <div class="font-medium text-3xl">باشگاه شاداب</div>
          </div>
          <div class="flex items-center justify-center rounded-border bg-white" style="width: 2.5rem; height: 2.5rem;">
            <i class="pi pi-check text-xl!" style="color:#06b6d4;"></i>
          </div>
        </div>
        <span class="font-medium" style="opacity:.9;">وضعیت: فعال</span>
      </div>
    </div>

    <!-- تاریخ -->
    <div class="col-span-12 lg:col-span-6 xl:col-span-3">
      <div class="card mb-0" style="background:#e11d48; color:#fff;">
        <div class="flex justify-between mb-4">
          <div>
            <span class="block font-medium mb-2" style="opacity:.9;">تاریخ</span>
            <div class="font-medium text-3xl" style="letter-spacing:1px;">{{ persianDate }}</div>
          </div>
          <div class="flex items-center justify-center rounded-border bg-white" style="width: 2.5rem; height: 2.5rem;">
            <i class="pi pi-calendar text-xl!" style="color:#e11d48;"></i>
          </div>
        </div>
        <span class="font-medium" style="opacity:.9;">روز خوبی داشته باشید</span>
      </div>
    </div>

    <!-- کاربر -->
    <div class="col-span-12 lg:col-span-6 xl:col-span-3">
      <div class="card mb-0" style="background:#f59e0b; color:#fff;">
        <div class="flex justify-between mb-4">
          <div>
            <span class="block text-muted-color font-medium mb-2">کاربر</span>

            @if (user$ | async; as user) {
              <div class="text-surface-900 dark:text-surface-0 font-medium text-2xl">
                {{ (user.fullName || ((user.firstName || '') + ' ' + (user.lastName || '')).trim() || user.username) }}
              </div>
            } @else {
              <div class="text-surface-900 dark:text-surface-0 font-medium text-2xl">-</div>
            }
          </div>

          <div class="flex items-center justify-center bg-green-100 dark:bg-green-400/10 rounded-border"
               style="width: 2.5rem; height: 2.5rem">
            <i class="pi pi-user text-green-500 text-xl!"></i>
          </div>
        </div>

        @if (user$ | async; as user) {
          <span class="text-primary font-medium">{{ user.username }}</span>
        } @else {
          <span class="text-muted-color">وارد نشده</span>
        }
      </div>
    </div>
  `
})
export class StatsWidget implements OnInit, OnDestroy {
  time = '';
  persianDate = '';
  user$: Observable<CurrentUser | null>;
  private timerId?: number;

  constructor(private auth: AuthService) {
    this.user$ = this.auth.user$;
  }

  ngOnInit(): void {
    this.tick();
    this.timerId = window.setInterval(() => this.tick(), 1000);
  }

  ngOnDestroy(): void {
    if (this.timerId) window.clearInterval(this.timerId);
  }

  private tick() {
    const now = new Date();

    // ⏰ ساعت تهران
    this.time = new Intl.DateTimeFormat('fa-IR', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
      timeZone: 'Asia/Tehran',
    }).format(now);

    // 📅 تاریخ شمسی تهران
    const raw = new Intl.DateTimeFormat('fa-IR-u-ca-persian', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      timeZone: 'Asia/Tehran',
    }).format(now);

    this.persianDate = raw.replace(/-/g, '/').replace(/\./g, '/');
  }
}
